export const otp = {
  /* Layout */
  rightPanel:
    "flex flex-1 items-start justify-center bg-[#FBFBF8] px-5 py-6 sm:px-8 sm:py-8",

  form:
    "w-full max-w-[340px] sm:max-w-[420px] lg:max-w-[470px] flex flex-col",

  /* Back */
  backButton:
    "mb-10 sm:mb-14 flex h-10 sm:h-11 w-fit items-center rounded-full border border-[#DDD8CB] bg-[#F7F4EC] px-4 sm:px-5 text-[14px] sm:text-[16px] font-medium text-[#13211B] hover:bg-[#F2EFE6]",

  /* Heading */
  title:
    "text-center font-fraunces text-[26px] sm:text-[32px] lg:text-[36px] leading-tight font-medium text-[#13211B]",

  subtitle:
    "mt-3 text-center text-[15px] sm:text-[16px] leading-6 text-[#6D7C75]",

  destination:
    "mt-1 text-center text-[15px] sm:text-[16px] font-semibold text-[#13211B] break-all",

  editLink:
    "mx-auto mt-4 rounded-full border border-[#DDD8CB] bg-[#F7F4EC] px-4 sm:px-5 py-2 text-[14px] sm:text-[15px] font-semibold text-[#13211B]",

  /* OTP */
  otpRow:
    "mt-8 flex justify-center gap-2 sm:gap-3",

  otpInput:
    "h-[56px] w-[44px] sm:h-[64px] sm:w-[56px] rounded-xl sm:rounded-2xl border border-[#DDD8CB] bg-[#F7F4EC] text-center text-[22px] sm:text-[28px] font-semibold outline-none transition focus:border-[#1D9E75] focus:ring-4 focus:ring-[#1D9E75]/10",

  /* Resend */
  resendSection:
    "mt-5 sm:mt-6 flex items-center justify-between",

  resendCount:
    "text-[12px] sm:text-[14px] text-[#A7B2AE]",

  timer:
    "text-[13px] sm:text-[15px] font-semibold text-[#667A73]",

  resendButton:
    "text-[13px] sm:text-[15px] font-semibold text-[#0B8B64]",

  /* Remember */
  rememberRow:
    "mt-6 flex items-start gap-3 sm:gap-4 rounded-2xl border border-[#DDD8CB] bg-[#F7F4EC] p-4 sm:p-5",

  checkbox:
    "mt-1 h-5 w-5 accent-[#1D9E75]",

  rememberTitle:
    "text-[16px] sm:text-[18px] font-semibold text-[#13211B]",

  rememberSubtitle:
    "mt-1 text-[13px] sm:text-[14px] leading-5 sm:leading-6 text-[#98A7A2]",

  /* Need Help */
  needHelp:
    "mt-6 text-center text-[14px] sm:text-[15px] font-semibold text-[#A6B1AE]",

  /* Verify */
  verifyButton:
    "mt-4 h-12 sm:h-14 w-full rounded-xl sm:rounded-2xl text-[16px] sm:text-[18px] font-semibold transition",

  verifyActive:
    "bg-[#1D9E75] text-white hover:bg-[#18835f]",

  verifyDisabled:
    "border border-[#DDD8CB] bg-[#F4F1E9] text-[#AEB6B2]",
};